import { useMemo } from 'react';
import { PCDBPart, VMRSPart } from '@/types/parts';

interface UsePartsGroupingProps {
  pcdbParts: PCDBPart[];
  vmrsParts: VMRSPart[];
}

interface UsePartsGroupingReturn {
  pcdbParts: PCDBPart[];
  vmrsParts: VMRSPart[];
  totalCount: number;
  avgScore: number;
}

export const usePartsGrouping = ({ 
  pcdbParts, 
  vmrsParts 
}: UsePartsGroupingProps): UsePartsGroupingReturn => {
  return useMemo(() => {
    // Calculate total count and average score (keep original 0.x values)
    const totalCount = pcdbParts.length + vmrsParts.length;
    const totalScore = [...pcdbParts, ...vmrsParts].reduce((sum, part) => {
      return sum + part.score;
    }, 0);
    const avgScore = totalCount > 0 ? totalScore / totalCount : 0;

    return {
      pcdbParts,
      vmrsParts,
      totalCount,
      avgScore
    };
  }, [pcdbParts, vmrsParts]);
};
